import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-softbar',
  templateUrl: './softbar.component.html',
  styleUrls: ['./softbar.component.scss'],
})
export class SoftbarComponent implements OnInit {
  @Input() lang: string = '';
  @Input() environmentVariables: any;
  constructor() {}

  ngOnInit(): void {}
}
